import type { InternalAxiosRequestConfig } from 'axios'

import { getEntraAuthorizeUrl } from '@/auth/entraConfig'
import { clearTokens, getAccessToken, hasExpiredEntraAccessToken, hasValidEntraAccessToken } from '@/data/api/token'
import { useAuthStore } from '@/store/authStore'

/** Attach Entra Bearer when valid; expired session → clear and re-auth. */
export const authInterceptor = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
  if (hasExpiredEntraAccessToken()) {
    clearTokens()
    useAuthStore.setState({ user: null, isAuthenticated: false })
    void getEntraAuthorizeUrl().then((url) => {
      window.location.assign(url)
    })
    return config
  }

  if (hasValidEntraAccessToken()) {
    const token = getAccessToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
  }

  return config
}
